module.exports = __webpack_public_path__ + "static/media/PIBKG_charcoal.ed33ea4a.png";